"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyToClipboard = exports.createUrlArgs = exports.parsePath = exports.parseHost = exports.replaceAll = exports.htmlDecode = exports.clearHtmlToText = exports.lowercaseFirstLetter = exports.uppercaseFirstLetter = exports.formalForNumber = void 0;
const gs = require("..");
/** Clear string for parse to number */
function formalForNumber(value) {
    if (!value)
        return value;
    let result = value;
    result = result.replace(/[,]/g, '.');
    result = result.replace(/[^-.,\d]/g, '');
    return result;
}
exports.formalForNumber = formalForNumber;
function uppercaseFirstLetter(string) { return string.charAt(0).toUpperCase() + string.slice(1); }
exports.uppercaseFirstLetter = uppercaseFirstLetter;
function lowercaseFirstLetter(string) { return string.charAt(0).toLowerCase() + string.slice(1); }
exports.lowercaseFirstLetter = lowercaseFirstLetter;
function clearHtmlToText(html) {
    return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
exports.clearHtmlToText = clearHtmlToText;
function htmlDecode(text) { return gs.html.p(text).textContent; }
exports.htmlDecode = htmlDecode;
;
function replaceAll(str, target, replace) {
    return str.replace(new RegExp(target, 'g'), replace);
}
exports.replaceAll = replaceAll;
function parseHost(url) {
    const a = gs.html.a({ href: url });
    return a.host;
}
exports.parseHost = parseHost;
function parsePath(url) {
    const a = gs.html.a({ href: url });
    return a.pathname;
}
exports.parsePath = parsePath;
function createUrlArgs(data) {
    const urlArgs = [];
    for (const key in data)
        urlArgs.push(`${key}=${encodeURIComponent(data[key])}`);
    return urlArgs.join('&');
}
exports.createUrlArgs = createUrlArgs;
;
function copyToClipboard(text) {
    const textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const successful = document.execCommand('copy');
    gs.w(textarea).cut();
    return successful;
}
exports.copyToClipboard = copyToClipboard;
;
//# sourceMappingURL=text.js.map